import React, { useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import Left from './left';
import BreadCrumb from '../../../common/components/Breadcrumb';
import { getAdminDashStats } from '../../../API/Statistics';

const breadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard'
    }
];

const Dashboard = () => {
    useEffect(() => {
        getAdminDashStats().then((response) =>
            console.log('Response fetched', response)
        );
    }, []);

    return (
        <Box>
            <Grid container sm={12}>
                <Grid item sm={12}>
                    <Box my={1} mx={9}>
                        <Box mb={4}>
                            {' '}
                            <BreadCrumb breadItems={breadcrumb} />
                        </Box>
                        {/* <DataCard /> */}
                        <Left />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Dashboard;
